<template>
  <div>
    <el-dialog title="开课记录"
               :visible.sync="dialogFormVisible"
               :close-on-click-modal="false"
               width="1200px"
               @close="emitClose"
               @open="open()">

      <el-table class="table"
                :data="results"
                border
                style="width: 100%">
        <el-table-column type="index"
                         label="序号"
                         width="64"
                         align="center"
                         fixed="left"></el-table-column>
        <el-table-column prop="ref_start_product_code"
                         label="开课码"
                         min-width="200"
                         align="center">
        </el-table-column>
        <el-table-column prop="ref_product_name"
                         label="商品名称"
                         align="center"
                         width="320"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="ref_product_type"
                         label="商品类型"
                         align="center">
          <template slot-scope="scope">
            <span v-show="scope.row.ref_product_type == '1'">课程</span>
            <span v-show="scope.row.ref_product_type == '2'">题库</span>
            <span v-show="scope.row.ref_product_type == '3'">专栏</span>
            <span v-show="scope.row.ref_product_type == '4'">资料</span>
          </template>
        </el-table-column>
        <el-table-column prop="exchange_status"
                         label="状态"
                         width="110"
                         align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.exchange_status==1"
                    type="success">开课中</el-tag>
            <el-tag v-if="scope.row.exchange_status==2"
                    type="warning">已开课</el-tag>

          </template>
        </el-table-column>

        <el-table-column prop="create_time"
                         label="开课时间"
                         width="160"
                         align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.create_time">{{$moment(scope.row.create_time).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>

        <el-table-column label="完成时间"
                         min-width="160"
                         align="center">
          <template slot-scope="scope">
            <span>{{$moment(scope.row.exchange_finish_time).format('YYYY-MM-DD HH:mm')}}</span>
          </template>
        </el-table-column>

      </el-table>
      <div class="footer">

        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { adminUrl } from '../../../utils/helper'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      dialogFormVisible: this.visible,
      results: [],
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        uid: null, // 添加这个
      },
      pageTotal: 10,
      start_code_task_id: null,
    }
  },
  mounted() {},
  watch: {
    visible(val) {
      this.dialogFormVisible = val
    },
    editRow(val) {
      this.query.uid = val.student_bind_uid
      this.getList()
    },
  },
  methods: {
    emitClose() {
      this.query.pageIndex = 1
      this.start_code_task_id = null
      this.results = []
      this.$emit('close')
    },
    copyCode(code) {
      if (!code) return this.$message.warning('开课码为空')
      this.$copyText(code).then((e) => {
        this.$notify.success({
          title: '提示',
          message: '复制成功',
          type: 'success',
        })
      })
    },
    async getList() {
      let data = this.query
      console.log('data', data)
      let str = adminUrl()
      const res = await this.$axios({
        url: `${str}/api/v1/back/product/startProductCode/exchangeLog/list`,
        method: 'get',
        params: data,
      })
      this.results = res.data.list
      this.pageTotal = res.data.count
    },
    open() {},
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.getList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getList()
    },
  },
}
</script>

<style lang="less" scoped>
.input-new-tag {
  width: 90px;
}
.el-tag {
  line-height: 32px;

  height: 32px;
  margin: 0px 5px;
}
.tips {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}
</style>